var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F73A54",
    fillRule: "evenodd",
    d: "M13.73 1.994c-.77-1.33-2.69-1.33-3.46 0L1.003 17.998C.232 19.33 1.194 21 2.734 21h18.532c1.54 0 2.502-1.669 1.73-3.002L13.731 1.994zM2.735 19 12 2.996 21.265 19H2.735zM13 7v6h-2V7h2zm0 8.5v.5a1 1 0 1 1-2 0v-.5a1 1 0 1 1 2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconWarning;